import SectionHeading from '../../components/SectionHeading';
import RichText from '../../components/RichText';
import Loader from '../../components/Loader';
import useFetch from '../../hooks/useFetch';
import { getTestimonials } from '../../services/api';

const FALLBACK_TESTIMONIALS = [
  {
    id: '1',
    quote:
      'Nation Wholesale transformed how we source products. Their reliability and the quality of their documentation have made Amazon ungating so much smoother for our team.',
    author_name: 'John D.',
    author_role: 'Amazon FBA Retailer',
    avatar_initials: 'JD',
  },
  {
    id: '2',
    quote:
      'As a growing FBA seller, I needed a partner who really understands Amazon compliance. Nation Wholesale exceeded every expectation — fast shipping, proper LOA, and great prices.',
    author_name: 'Sarah M.',
    author_role: 'Amazon Seller',
    avatar_initials: 'SM',
  },
  {
    id: '3',
    quote:
      'The customer service here is exceptional. They understand our needs and always provide tailored solutions. Best wholesale partner we\'ve worked with in years.',
    author_name: 'Michael T.',
    author_role: 'Small Business Owner',
    avatar_initials: 'MT',
  },
];

function TestimonialsSection() {
  const { data, loading } = useFetch(() => getTestimonials(), []);

  if (loading) {
    return (
      <section className="testimonials-bg">
        <div className="section-inner">
          <Loader />
        </div>
      </section>
    );
  }

  const testimonials =
    Array.isArray(data) && data.length > 0 ? data : FALLBACK_TESTIMONIALS;

  return (
    <section className="testimonials-bg">
      <div className="section-inner">
        <SectionHeading
          label="Client Reviews"
          title="What Our Clients Say"
          sub="Hundreds of Amazon sellers and businesses trust Nation Wholesale as their wholesale partner."
        />
        <div className="testi-grid">
          {testimonials.map((t) => (
            <div className="testi-card" key={t.id}>
              <span className="testi-quote">"</span>
              <RichText html={t.quote} tag="p" />
              <div className="testi-author">
                <div className="testi-avatar">
                  {t.avatar_initials || getInitials(t.author_name)}
                </div>
                <div>
                  <div className="testi-name">{t.author_name}</div>
                  <div className="testi-role">{t.author_role}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

function getInitials(name) {
  if (!name) return '?';
  return name
    .split(' ')
    .slice(0, 2)
    .map((w) => w[0])
    .join('')
    .toUpperCase();
}

export default TestimonialsSection;
